module.exports = __webpack_public_path__ + "assets/img/heading_sm.485d1c84.png";